<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-per-page="10"
    :footer-props="{'items-per-page-text': 'Số popup một trang'}"
    disable-sort
    :server-items-length="count"
    v-bind="this.$attrs"
    :options.sync="pagination"
  >
    <template v-slot:[`footer.page-text`]="items">
      Popup thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} popup
    </template>

    <template v-slot:[`item.title`]="{item}">
      <div class="d-flex align-center py-2">
        <div style="height: 60px; width: 60px; background-color: lightgrey">
          <img v-if="item.imageUrl" :src="item.imageUrl" style="height: 60px; width: 60px; object-fit: contain" />
          <div
            v-else
            style="height: 60px; width: 60px; background-color: lightgrey"
            class="d-flex align-center justify-center"
            title="Chưa có ảnh đại diện"
          >
            <v-icon color="white">mdi-image-area</v-icon>
          </div>
        </div>
        <div class="ml-2">
          {{ item.title }}
        </div>
      </div>
    </template>
    <template v-slot:[`item.appliedType`]="{item}">
      {{ item.appliedType | getAppliedType
      }}<span v-if="item.appliedType === 'auth-grade'"> ({{ item | getAppliedFor }})</span>
    </template>
    <template v-slot:[`item.deadline`]="{item}">
      {{ item.deadline | getDeadlineTime }}
    </template>
    <template v-slot:[`item.linkTo`]="{item}">
      <a v-if="item.isExternal" :href="item.linkTo" target="_blank" />
      <div v-else>{{ item.linkTo | getLinkTo }}</div>
    </template>
    <template v-slot:[`item.isPublished`]="{item}">
      <v-chip :color="item.isPublished | getPublishedColor" small class="white--text">
        {{ item.isPublished ? 'Xuất bản' : 'Chưa xuất bản' }}
      </v-chip>
    </template>
    <template v-slot:[`item.isExpired`]="{item}">
      <v-chip :color="item.isExpired | getExpiredColor" small class="white--text">
        {{ item.isExpired ? 'Đã hết hạn' : 'Chưa hết hạn' }}
      </v-chip>
    </template>
    <template v-slot:[`item.actions`]="{item}">
      <v-btn icon @click="() => $emit('onDetail', {...item, isEdit: true})">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon @click="() => togglePublish(item)" :color="!item.isPublished ? 'admin' : 'error'">
        <v-icon>{{ !item.isPublished ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import {get} from 'lodash'
const baseHeaders = [
  {text: 'Tiêu đề', value: 'title'},
  {text: 'Hạn hiển thị', value: 'deadline'},
  {text: 'T.thái hiển thị', value: 'isPublished'},
  {text: 'T.thái hết hạn', value: 'isExpired'},
  {text: 'Đối tượng áp dụng', value: 'appliedType'},
  {text: 'Liên kết tới', value: 'linkTo'},
  {text: 'Thao tác', value: 'actions', align: 'center'},
]

export default {
  computed: {
    ...mapGetters('adsPopup', ['items', 'count']),
    ...mapGetters('auth', ['user']),
    headers() {
      return baseHeaders
    },
  },
  data: () => ({loading: false, pagination: {}}),
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.refresh((newOptions.page - 1) * newOptions.itemsPerPage, newOptions.itemsPerPage)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({fetchItems: 'adsPopup/fetchItems', updateItem: 'adsPopup/updateItem'}),
    async refresh(_start = 0, _limit = 10) {
      this.loading = true
      await this.fetchItems({_start, _limit, _sort: 'createdAt:DESC'})
      this.loading = false
    },
    togglePublish(item) {
      this.$dialog.confirm({
        title: 'Xác nhận đổi trạng thái',
        okText: 'Xác nhận',
        topContent: '',
        midContent: `Bạn có chắc chắn muốn đổi trạng thái hiển thị của Popup này sang "${
          item.isPublished ? 'Ngừng xuất bản' : 'Xuất bản'
        }" không? Nếu đã chắc chắn, vui lòng bấm vào nút xác nhận bên dưới để tiếp tục.`,
        botContent: '',
        cancelText: 'Kiểm tra lại',
        done: async () => {
          this.$loading.active = true
          try {
            await this.updateItem({id: item.id, isPublished: !item.isPublished})
            this.$alert.success('Đổi trạng thái hiển thị thành công')
            this.refresh()
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  filters: {
    getDeadlineTime: deadline => (!deadline ? '' : moment(deadline).format('DD/MM/YYYY HH:mm')),
    getAppliedType: appliedType => {
      switch (appliedType) {
        case 'all':
          return 'Tất cả'
        case 'nonAuth':
          return 'Chưa đăng nhập'
        case 'auth':
          return 'Đã đăng nhập'
        case 'auth-grade':
          return 'Có HS theo khối'
        case 'specific':
          return 'Tuỳ chỉnh'
        default:
          return ''
      }
    },
    getAppliedFor: item => {
      const grades = get(item, 'appliedForGrades', [])
      if (Array.isArray(grades) && grades.length) {
        return grades.join(', ')
      }
      return ''
    },
    getLinkTo: linkTo => {
      switch (linkTo) {
        case '/':
          return 'Trang chủ'
        case '/cv':
          return 'Trang danh sách HS'
        case '/login':
          return 'Trang đăng nhập'
        case '/register':
          return 'Trang đăng ký'
        default:
          return ''
      }
    },
    getPublishedColor(val) {
      return val ? 'green' : 'grey'
    },
    getExpiredColor(val) {
      return val ? 'red' : 'green'
    },
  },
}
</script>
